import { useState, useEffect } from 'react';

export function useConvexErrorHandling() {
  const [error, setError] = useState<Error | null>(() => {
    // Check for missing environment variables on initialization
    if (!import.meta.env.VITE_CONVEX_URL) {
      console.error('[Auth] Missing VITE_CONVEX_URL environment variable');
      return new Error(
        'Missing VITE_CONVEX_URL environment variable. Please check your .env file.'
      );
    }
    return null;
  });

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      const message = event.error?.message || '';
      
      if (message.includes('Could not find public function')) {
        setError(
          new Error(
            'Backend function not found. Please make sure the Convex backend is running.'
          )
        );
      } else if (
        message.includes('Failed to fetch') ||
        message.includes('NetworkError')
      ) {
        setError(
          new Error(
            'Network connection failed. Please check your internet connection and try again.'
          )
        );
      } else if (message.includes('ConvexError')) {
        setError(
          new Error(
            'Convex backend error. Please make sure the backend is running and properly configured.'
          )
        );
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (event.reason?.message?.includes('fetch')) {
        setError(
          new Error(
            'Connection to backend failed. Please check if the Convex backend is running.'
          )
        );
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return { error };
}